module.exports = __webpack_public_path__ + "img/two1Orange.a895cba7.jpg";